<template>
  <h3 class="pb5">Dossier actif par enquêteur(CDX_0103)</h3>
  <CritereRechercheLoteries :onlyShowDate="true" :showDateEntreLe="false" :showDateEtLe="false"
                            ref="critereRechercheLoteries"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheLoteries from "@/components/rapports/Rechercher/CritereRechercheLoteries.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossierActifParEnquêteurCDX_0103",
  components: {CritereRechercheLoteries, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Loteries");
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      criteresRapportVO: {}
    }
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.criteresRapportVO.titre = "DossierActifParEnquêteur_CDX_0103";
      this.criteresRapportVO.nomRapport = "loteries.DossierActifParEnquêteur_CDX_0103";
      this.$store.dispatch("rapports/obtenirRapportAction",
          this.criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>